import { AttributeOperators } from '@enums/strapiTypesAndOperators'
import { QueryOptions } from '@interfaces/strapi'

export function buildQueryParams(options: QueryOptions): URLSearchParams {
  const params: Record<string, any> = {}

  if (options.populate?.length === 1) {
    params.populate = options.populate[0]
  } else {
    options.populate?.forEach((field, index) => {
      params[`populate[${index}]`] = field
    })
  }

  options.filters?.forEach(({ key, operator = AttributeOperators.EQUAL_TO, value }) => {
    const filterPath = key
      .split('.')
      .map(p => `[${p}]`)
      .join('')
    params[`filters${filterPath}[${operator}]`] = value
  })
  options.fields?.forEach((field, index) => {
    params[`fields[${index}]`] = field
  })

  const addEntries = (entries: Record<string, any>) => {
    Object.entries(entries).forEach(([key, value]) => {
      if (value) {
        params[key] = value
      }
    })
  }

  addEntries({
    ...(options.sort ? { sort: `${options.sort}:${options.order}` } : {}),
    ...(options.limit ? { 'pagination[start]': options.start, 'pagination[limit]': options.limit } : {}),
    ...(options.page ? { 'pagination[page]': options.page, 'pagination[pageSize]': options.pageSize } : {}),
    publicationState: options.publicationState,
    status: options.status,
    locale: options.locale,
  })

  return new URLSearchParams(params)
}
